import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ICONS } from 'src/assets/library';
import { signinFormScheme } from 'src/config/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import CustomTextField from 'src/components/formFields/textField';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SIGNIN } from 'src/apiService/apiDeclaration';
import { constants, OTP_VERIFICATION_MODE, showErrorTost, showSuccessTost } from 'src/constants';
import { storeData } from 'src/helper/storageHelper';
import { getLoggedInUser } from 'src/redux/features/auth/actions';
import { setToken } from 'src/redux/features/auth/slice';
import { useTranslation } from 'react-i18next';
import SocialLogin from '../common/socialLogin';

const SigninForm = ({ loading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    // onChange so validation errors render as the user types. With onSubmit the button
    // is disabled while invalid, so the submit that would surface the errors never runs.
    mode: 'onChange',
    resolver: yupResolver(signinFormScheme),
  });

  const onSignin = async (data) => {
    try {
      const resp = await SIGNIN(data);

      if (resp.data?.token) {
        storeData(constants.authToken, resp.data.token);
        dispatch(setToken(resp.data.token));
        dispatch(getLoggedInUser());
      } else {
        navigate('/otp', { state: { email: data.email, verifcationMode: OTP_VERIFICATION_MODE.LOGIN } });
      }

      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
      console.error('Error during sign-in:', error);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSignin)}>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <CustomTextField
            placeholder={t('common.placeholderEmail')}
            type="email"
            icon={ICONS.email}
            controller={{
              name: 'email',
              control: control,
              errors: errors.email,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomTextField
            isPassword
            placeholder={t('common.password')}
            type="password"
            icon={ICONS.password}
            controller={{
              name: 'password',
              control: control,
              errors: errors.password,
            }}
          />
        </Grid>
        <Grid iteem xs={12} sx={{ display: 'flex', justifyContent: 'end', mt: 0.5 }}>
          <Typography variant="h8">
            <Link to={'/forgot-password'} style={{ color: '#ACD644', textDecoration: 'none' }}>
              {t('signinPage.forgotPassword')}
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <LoaderButton
            disabled={!isValid}
            loading={loading}
            buttonText={t('signinPage.action.signin')}
            type="submit"
          />
        </Grid>
        <Grid item xs={12}>
          <SocialLogin />
        </Grid>
      </Grid>
    </form>
  );
};

export default SigninForm;
